import DocumentsStore from "stores/documentsStore";
import { DocumentType } from "thunk-core";

export default class TemplatesStore extends DocumentsStore {
  constructor() {
    super(DocumentType.SNIPPET);
  }
}
